import React from 'react';
import { IssuedCoupon } from '../../api/userApi';

interface WelcomeModalProps {
  isOpen: boolean;
  onClose: () => void;
  issuedCoupons?: IssuedCoupon[];
}

const WelcomeModal: React.FC<WelcomeModalProps> = ({
  isOpen,
  onClose,
  issuedCoupons = []
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          {/* Header */}
          <div className="text-center mb-6">
            <div className="mb-4">
              <div className="text-7xl mb-3">
                🎉
              </div>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-3">
              회원가입을 축하합니다!
            </h2>
            <p className="text-gray-600 text-lg">
              굿타임렌트카에 오신 것을 환영합니다
            </p>
          </div>

          {/* Coupons Section */}
          {issuedCoupons.length > 0 && (
            <div className="mb-6">
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-5">
                <div className="text-center mb-4">
                  <p className="text-blue-800 font-bold text-lg mb-1">
                    🎁 회원가입 축하 쿠폰
                  </p>
                  <p className="text-blue-600 text-sm">
                    특별한 혜택을 받으셨습니다!
                  </p>
                </div>
                <div className="space-y-3">
                  {issuedCoupons.map((coupon, index) => (
                    <div
                      key={index}
                      className="bg-white rounded-lg p-4 shadow-sm border border-blue-100"
                    >
                      <div className="flex items-start justify-between mb-2">
                        <div className="flex-1">
                          <div className="font-bold text-gray-900 text-lg mb-1">
                            {coupon.name}
                          </div>
                          <div className="text-sm text-gray-600 mb-2">
                            {coupon.description}
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center justify-between pt-2 border-t border-gray-100">
                        <div className="text-blue-600 font-semibold">
                          {coupon.discount_type === 'PERCENTAGE'
                            ? `${coupon.discount_value}% 할인`
                            : `${coupon.discount_value.toLocaleString()}원 할인`}
                        </div>
                        <div className="text-xs text-gray-500">
                          유효기간: {new Date(coupon.valid_until).toLocaleDateString()}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="mt-4 text-center text-sm text-blue-700">
                  쿠폰은 마이페이지에서 확인하실 수 있습니다
                </div>
              </div>
            </div>
          )}

          {/* Welcome Message */}
          {issuedCoupons.length === 0 && (
            <div className="mb-6 p-5 bg-gray-50 rounded-lg">
              <p className="text-gray-700 text-center leading-relaxed">
                굿타임렌트카의 다양한 차량과<br />
                편리한 서비스를 이용해보세요!
              </p>
            </div>
          )}

          {/* Close Button */}
          <button
            onClick={onClose}
            className="w-full bg-blue-600 text-white py-4 rounded-lg font-bold text-lg hover:bg-blue-700 transition-colors shadow-md"
          >
            시작하기
          </button>

          {/* Additional Info */}
          <div className="mt-4 text-center">
            <p className="text-sm text-gray-500">
              지금 바로 차량을 예약하고 특별한 가격으로 이용하세요
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
